import axios from "axios"
import {urlDomain } from '../../config/constant'

const apiDomain = urlDomain();

export const get_ak = (empid) =>{

    const apiUrl = `${apiDomain}/loginotpgeneration?usertype=999&display=-1&empid=${empid}`

    return axios.get(apiUrl)
}